import { createClient } from '@supabase/supabase-js';
import {
  REACT_APP_SUPABASE_URL,
  REACT_APP_SUPABASE_ANON_KEY,
} from './constants';

if (!REACT_APP_SUPABASE_URL)
  throw new Error('Missing env.REACT_APP_SUPABASE_URL');
if (!REACT_APP_SUPABASE_ANON_KEY)
  throw new Error('Missing env.REACT_APP_SUPABASE_ANON_KEY');

const isProdMod = process.env.NODE_ENV === 'production';
console.log('[Supabase] REACT_APP_SUPABASE_URL:', REACT_APP_SUPABASE_URL);
export const supabaseStorage = createClient(
  REACT_APP_SUPABASE_URL,
  REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      storage: window.localStorage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  }
);

export const supabase = createClient(
  REACT_APP_SUPABASE_URL,
  REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      storage: window.localStorage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
    // Chrome throttles timers in background tabs, and realtime's heartbeat is
    // a timer — a hidden tab could silently lose its socket, which is exactly
    // when a desktop notification is needed. The worker (an inline blob, no
    // extra request) keeps the heartbeat going. The inbox's 5-minute poll
    // stays as the safety net.
    realtime: { worker: true }
  }
);
